module.exports = __webpack_public_path__ + "img/turntable_bg.766f7c15.png";